<template>
  <div>
    <vx-card>
      <h3 class="mb-3">{{ $t('play_sound') }}</h3>
    </vx-card>
    <vx-card id="uploadSoundFileContainer" class="mb-8 vs-con-loading__container">
      <template slot="actions">
      </template>
      <vs-table hover-flat v-if="soundFiles && soundFiles.length" :data="soundFiles">
        <template slot="thead">
          <vs-th v-text="$t('file_name')"></vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <a href="#" v-text="tr.file" @click="playSoundFile(tr.id)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template slot="footer">
        <paginate
          :total="soundFilePages"
          :click-handler="loadSoundFiles"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>
  </div>
</template>

<script>

import SoundFile from '@/models/SoundFile'
import Paginate from '@/mixins/paginate'

export default {
  name: 'Window.SoundFile.List',
  mixins: [Paginate],
  data () {
    return {
      soundFiles: {},
      soundFilePages: 0,
      extension: ''
    }
  },
  mounted () {
    this.extension = this.$route.params.extension
    this.loadSoundFiles(this.initialPage)
  },
  methods: {
    reloadSoundFiles () {
      this.loadSoundFiles(this.initialPage)
    },
    async loadSoundFiles (page = 1, backToPageOne = false) {
      this.$vs.loading({container: '#uploadSoundFileContainer'})

      const response = await SoundFile.all({ ...this.soundFileSearchParams, page })
      this.soundFiles = response.data.data.soundFiles
      this.soundFilePages = response.data.meta.pagination.last_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#uploadSoundFileContainer > .con-vs-loading')
    },
    async playSoundFile (id) {
      try {
        await SoundFile.play({ id, extension: this.extension })
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

    }
  }
}
</script>

<style scoped>

</style>
